// extracted by mini-css-extract-plugin
export default {"festival":"festival_festival__-IFAX","infiniteScrollDiv":"festival_infiniteScrollDiv__8I+YR"};